import { GET_TICKET_TEMPLATES } from "constants/ticketTemplates";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_TICKET_TEMPLATES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
